// require('./starCheckbox.scss');

const React = require('react');
const classNames = require('classnames');
const PropTypes = require('prop-types');
const StarCheckbox = require('components/broker/commons/starCheckbox/starCheckbox');

class MorningStarCheckboxGroup extends React.Component {

    constructor(props) {
        super(props);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    handleCheckboxChange(index, stars) {
        return (event) => {
            this.props.onChange({index, stars, checked: event.target.checked});
        }
    }

    render() {
        const { values, extraClass } = this.props;
        const className = classNames('morningstar-checkbox-group', extraClass);
        const checkboxes = values.map((checkbox, index) => {
            return (
                <StarCheckbox
                    key={index}
                    stars={checkbox.stars}
                    idName={`morningStar${checkbox.stars}Stars`}
                    value={checkbox.checked}
                    onChange={this.handleCheckboxChange(index, checkbox.stars)}
                />
            );
        });
        return (
            <div className={className}>
                {checkboxes}
            </div>
        );
    }
}

MorningStarCheckboxGroup.propTypes = {
    values: PropTypes.array.isRequired,
    extraClass: PropTypes.string,
    onChange: PropTypes.func
};

module.exports = MorningStarCheckboxGroup;
